<form [formGroup]="prospectForm">
  <div tiimeFormTitle>Informations Prospect</div>
  <div class="content-form">
    <tiime-input-container
      label="Prénom"
      required="true"
      contentId="firstName"
      [errorMessage]="prospectForm.firstNameErrorMessage?.message"
    >
      <input
        #firstNameInput
        id="firstName"
        type="text"
        formControlName="firstName"
        placeholder="Nom"
        autocomplete="off"
      />
    </tiime-input-container>
    <tiime-input-container
      label="Nom"
      required="true"
      contentId="lastName"
      [errorMessage]="prospectForm.lastNameErrorMessage?.message"
    >
      <input
        id="lastName"
        type="text"
        formControlName="lastName"
        placeholder="Nom"
        autocomplete="off"
        appUppercaseInput
      />
    </tiime-input-container>
    <app-user-civility-select [selectData]="civilities" [control]="prospectForm.civility"></app-user-civility-select>
    <tiime-input-container
      class="email-input"
      label="Email"
      required="true"
      contentId="email"
      [errorMessage]="prospectForm.emailErrorMessage?.message"
    >
      <input id="email" type="email" formControlName="email" placeholder="Email" autocomplete="off" />
    </tiime-input-container>
    <tiime-input-container
      label="Téléphone"
      required="true"
      contentId="phone"
      [errorMessage]="prospectForm.phoneErrorMessage?.message"
    >
      <input id="phone" type="text" formControlName="phone" placeholder="Téléphone" />
    </tiime-input-container>
    <tiime-input-container class="adress-input" label="Adresse" contentId="mailingStreet">
      <input id="mailingStreet" type="text" formControlName="mailingStreet" placeholder="Adresse" autocomplete="off" />
    </tiime-input-container>
    <tiime-input-container label="Code postal" contentId="mailingPostalCode">
      <input
        id="mailingPostalCode"
        type="text"
        formControlName="mailingPostalCode"
        placeholder="Code postal"
        autocomplete="off"
      />
    </tiime-input-container>
    <tiime-input-container class="city-input" label="Ville" contentId="mailingCity">
      <input id="mailingCity" type="text" formControlName="mailingCity" placeholder="Ville" autocomplete="off" />
    </tiime-input-container>
  </div>
  <div tiimeFormVerticalSeparator></div>
  <div tiimeFormTitle>Entreprise</div>
  <div class="content-form">
    <app-legal-form-select
      contentId="legalForm"
      [selectData]="legalForms"
      [control]="prospectForm.companyLegalForm"
    ></app-legal-form-select>
    <tiime-input-container
      label="Nom entreprise"
      required="true"
      contentId="companyName"
      [errorMessage]="prospectForm.companyNameErrorMessage?.message"
    >
      <input
        id="companyName"
        type="text"
        formControlName="companyName"
        placeholder="Nom entreprise"
        autocomplete="off"
      />
    </tiime-input-container>
    <tiime-input-container
      [errorMessage]="prospectForm.caForecastAmountErrorMessage?.message"
      label="CA prévisionnel ou réalisé"
      contentId="caForecastAmount"
    >
      <input
        id="caForecastAmount"
        type="text"
        formControlName="caForecastAmount"
        placeholder="CA prévisionnel ou réalisé"
        autocomplete="off"
        min="0"
        appDigitOnly
      />
      <mat-icon
        fontSet="fontastic"
        fontIcon="icon-ic-info"
        tiimeTooltip="Ce champ correspond au CA prévisionnel en cas de début d'activité, ou le CA réalisé pour une reprise de comptabilité"
        tiimeSuffix
      ></mat-icon>
    </tiime-input-container>
  </div>
  <div tiimeFormVerticalSeparator></div>
  <div tiimeFormTitle>Affectation</div>
  <div class="content-form">
    <app-business-unit-select
      [required]="true"
      [selectData]="businessUnits"
      [control]="prospectForm.businessUnit"
      [errorMessage]="prospectForm.businessUnitErrorMessage"
    ></app-business-unit-select>
    <app-contributor-select
      label="Référent commercial"
      searchPlaceholder="Rechercher un référent commercial"
      [control]="prospectForm.salesRepresentativeUser"
      [partner]="partner"
    ></app-contributor-select>
    <div class="flex row gap-10">
      <div class="flex gap-5 end">
        <tiime-input-container contentId="appointmentDate" label="Date RDV">
          <input
            id="appointmentDate"
            type="text"
            [matDatepicker]="datePicker"
            placeholder="Date RDV"
            formControlName="appointmentDate"
            autocomplete="off"
          />
          <mat-icon
            color="primary"
            class="calendar-icon"
            fontSet="fontastic"
            fontIcon="icon-calendar"
            tiimeSuffix
            (click)="datePicker.open()"
          ></mat-icon>
          <mat-datepicker
            panelClass="tiime-material-datepicker"
            [calendarHeaderComponent]="tiimeDatepickerHeader"
            [disabled]="prospectForm.disabled"
            #datePicker
          ></mat-datepicker>
        </tiime-input-container>
        <mat-icon
          fontSet="fontastic"
          fontIcon="icon-ic-info"
          tiimeTooltip="Un email de rappel sera automatiquement envoyé au prospect un jour avant la date prévue du rendez-vous."
        ></mat-icon>
      </div>
      <tiime-input-container contentId="appointmentTime" label="À">
        <input id="appointmentTime" type="time" placeholder="À" formControlName="appointmentTime" autocomplete="off" />
      </tiime-input-container>
    </div>
    <app-code-and-label-select
      [required]="true"
      label="Canal d'acquisition"
      [control]="prospectForm.acquisitionChannel"
      [options]="acquisitionChannels"
      [errorMessage]="prospectForm.acquisitionChannelErrorMessage"
      [allowEmptyOption]="false"
    />
    <tiime-input-container
      label="Commentaire de canal"
      contentId="complementChannel"
      [errorMessage]="prospectForm.complementChannelErrorMessage?.message"
    >
      <input
        id="complementChannel"
        type="text"
        formControlName="complementChannel"
        placeholder="Commentaire de canal"
        autocomplete="off"
      />
    </tiime-input-container>
    <app-tiime-business-pro-account-intention-select
      [control]="prospectForm.tiimeBusinessProAccountIntention"
      [options]="tiimeBusinessProAccountIntentions"
    />
  </div>
  <div tiimeFormVerticalSeparator></div>
  <div tiimeFormTitle>Note interne</div>
  <tiime-input-container contentId="internal-comment">
    <textarea
      id="internal-comment"
      formControlName="internalComment"
      cdkTextareaAutosize
      cdkAutosizeMinRows="2"
    ></textarea>
  </tiime-input-container>
</form>
